import { connect } from 'react-redux';
import {
  fetchReports,
  reportingAppFilter
} from '../../redux/actions/reportingActions';
import Dashboard from './Dashboard';
import { ALL_APPS } from '../../utils/constants';

const mapStateToProps = ({
  apps,
  reports: {
    loading,
    data,
    ui: { analytics, revenues },
    filters: { app }
  }
}) => {
  const appsList = apps.sortedList.map(({ name }) => name);
  return {
    apps: [ALL_APPS, ...appsList],
    app,
    analytics,
    revenues,
    loading,
    appsLoading: apps.loading
  };
};

const mapDispatchToProps = dispatch => ({
  fetchAllReports: (startDate, endDate, appName, shouldAppsFetching) =>
    dispatch(fetchReports(startDate, endDate, appName, shouldAppsFetching)),
  filterReports: appName => dispatch(reportingAppFilter(appName))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Dashboard);



// WEBPACK FOOTER //
// ./src/components/dashboard/DashboardContainer.js